<template>
    <div>
        <c-column-header
            class="primary"
            label="Kunden"
        >
            <template v-slot:filter>
                <c-item-count :count="customers.length" />
            </template>
        </c-column-header>
        <div class="lm-border pa-3 mt-1 pb-3">
            <v-text-field
                v-model        = "search"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                append-icon    = "fas fa-search"
                :clearable     = "true"
                @input         = "onSearch"
                dense
                hide-details
            />
        </div>
        <div class="mt-1 pt-1 mb-2 item-container">
            <v-list class="pt-1 lm-border mr-1">
                <v-list-item
                    v-for   = "(customer,index) in customers"
                    :key    = "index"
                    :ripple = "false"
                    @click  = "onCustomer(customer)"
                    class   = "pr-1"
                    :class  = "selected && selected.id === customer.id ? 'item-selected' : 'lightgray'"
                    dense
                >
                    <div class="item-text v-flex w-100" >
                        <div>
                            {{ customer.name}}
                        </div>
                    </div>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>

<script>

import CItemCount from "@/modules/core/components/utils/CItemCount";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import Core from "@/modules/core/service/Core";

export default {
    name: "ServiceCustomerList",
    components: {
        CColumnHeader,
        CItemCount,
    },

    data: () => ({
        selected : null,
        search   : null,
        customers: []
    }),

    computed: {
        msd () {
            return this.$store.getters.msd;
        },
    },

    watch: {
        company () {
            this.load();
        }
    },

    mounted() {
        this.load();
    },

    methods: {
        load () {
            this.customers = this.msd.limCustomer;
        },

        reset () {
            this.selected = null;
        },

        onSearch () {
            console.log(this.search)
            if (!this.search || this.search.length === 0) {
                this.customers = this.msd.limCustomer;
                return;
            }

            this.customers = this.msd.limCustomer.filter (customer => Core.filter.includes(customer.name, this.search));
        },

        onCustomer (customer) {
            if (this.selected && this.selected.id === customer.id) {
                this.selected = null;
            } else {
                this.selected = customer;
            }

            this.$emit("customer", this.selected);
        },
    }
}
</script>

<style scoped>

::v-deep .v-list--dense .v-list-item, .v-list-item--dense {
    min-height: 30px;
}

</style>

<style lang="scss" scoped>

.item-selected {
    height: 30px;
    background-color: #e8e8e8;
}

.item-container {
    height: calc(100% - 30px);
    overflow-y: scroll;
    width: calc(100% + 11px);
}

::v-deep .theme--light.v-list-item:hover {
    background-color: white;
    color: black!important;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: black!important;
}

::v-deep .v-list-item {
    padding: 0 10px;
    margin-right: 0;
}


.item-text {
    max-width: calc(100%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}

</style>
